import { ValidatorFn, Validators } from '@angular/forms';
import { OpenProduct } from '../../core/api/products/entities/product-action.entity';
import { ProductActiveStockItem } from '../../core/api/products/entities/product-active-stock-item.entity';
import { QuantityUnit } from '../../core/api/quantity-units/entities/quantity-unit.entity';
import { positive } from '../form-control-options.constants';
import { QuickActionOpenFormControls } from '../form-controls/quick-action.form-controls';
import { QuickActionForm } from './quick-action.form';

export class QuickActionOpenForm extends QuickActionForm<QuickActionOpenFormControls> {
  formGroup = this.createFormGroup(QuickActionOpenFormControls);

  public get amountHint(): string | undefined {
    return undefined;
  }

  public get productAction(): OpenProduct {
    const productAction: OpenProduct = {
      amount: this.amount,
      productId: this.product!.id,
    };

    if (this.controls.stockItem.value) {
      productAction.stockItemId = this.controls.stockItem.value.id;
    }

    return productAction;
  }

  public get quantityUnit(): QuantityUnit | undefined {
    return this.product?.quantityUnitStock;
  }

  public override canSelectStockItem(stockItem: ProductActiveStockItem): boolean {
    return !stockItem.openedAt;
  }

  public setAmountToMax(): void {
    if (this.product) {
      const { value: stockItem } = this.controls.stockItem;
      const { activeStockAmount, activeStockAmountOpened } = this.product;

      if (stockItem && !stockItem.openedAt) {
        this.controls.amount.setValue(stockItem.amount);
      } else {
        this.controls.amount.setValue((activeStockAmount || 0) - (activeStockAmountOpened || 0));
      }
    }
  }

  protected setChangeListeners(): void {
    this.controls.stockItem.valueChanges.subscribe(stockEntry => {
      let maxAmount = (this.product?.activeStockAmount || 0) - (this.product?.activeStockAmountOpened || 0);

      if (stockEntry) {
        maxAmount = stockEntry.openedAt ? 0 : stockEntry.amount;
      }

      if (maxAmount > 0) {
        this.controls.amount.setValue(this.product?.barcode?.amount || 1);
      }

      this.controls.amount.setValidators([Validators.required, Validators.min(0.000001), Validators.max(maxAmount)]);

      this.controls.amount.updateValueAndValidity();
    });
  }

  protected setInitialValues(): void {
    this.controls.amount.setValidators([
      ...(positive.validators as ValidatorFn[]),
      Validators.max((this.product?.activeStockAmount || 0) - (this.product?.activeStockAmountOpened || 0)),
    ]);
  }
}
